import { coerceNumberProperty } from '@angular/cdk/coercion';
import {
  AfterContentInit,
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  ContentChild,
  EventEmitter,
  HostBinding,
  Input,
  Output,
  TemplateRef,
  ViewChild,
  ViewEncapsulation,
} from '@angular/core';
import { NFormComponent, NFormOverrideContext } from '@pebula/nform';
import { UnRx } from '@pebula/utils';
import { AsyncTracker } from '@sg/utils/src';
import { BehaviorSubject, Observable } from 'rxjs';
import { debounceTime, distinctUntilChanged, take } from 'rxjs/operators';

@Component({
  selector: 'sg-report-query-host',
  templateUrl: './report-query-host.component.html',
  styleUrls: ['./report-query-host.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  encapsulation: ViewEncapsulation.None,
  standalone: false,
})
@UnRx()
export class SgReportQueryHostComponent implements AfterContentInit {
  @Input() hideSearchButton: boolean = false;
  @Input() buttonLabel: string = 'Search';
  @Input() tracker: AsyncTracker;
  @Input()
  get countHint(): number {
    return this._countHint.length;
  }
  set countHint(value: number) {
    value = coerceNumberProperty(value);
    if (this._countHint.length !== value) {
      this._countHint = new Array(value);
    }
  }
  @Output() querySubmit = new EventEmitter<void>();
  @Output() contentInitialized = new EventEmitter<void>();
  @ViewChild('queryItemTpl', { read: TemplateRef, static: true }) queryItemTpl: TemplateRef<NFormOverrideContext>;
  @ContentChild(NFormComponent) dynForm: NFormComponent;
  @HostBinding('class.busy') get isBusy(): boolean {
    return this.busy$ ? (this.busy$ as any)._value : false;
  }

  private forceBusySubject = new BehaviorSubject<boolean>(false);

  _countHint: any[] = new Array(4);
  showLoadingFill = true;
  busy$: Observable<boolean>;

  constructor(private cdr: ChangeDetectorRef) {}

  ngAfterContentInit(): void {
    if (this.dynForm) {
      this.countHint = Object.keys(this.dynForm.form.controls).length;
      this.dynForm.addOverride({ controlName: '*' }, this.queryItemTpl, true);
      this.dynForm.formClass = 'sg-report-query-form';

      this.setupBusyObservable();

      this.dynForm.renderState.pipe(take(3)).subscribe({
        complete: () => {
          this.showLoadingFill = false;
          this.contentInitialized.emit();
          this.cdr.markForCheck();
        },
      });
    }
  }

  private setupBusyObservable(): void {
    if (this.tracker && this.tracker.busy$) {
      this.busy$ = this.tracker.busy$.pipe(debounceTime(10), distinctUntilChanged());
    } else {
      this.busy$ = this.forceBusySubject.asObservable().pipe(debounceTime(10), distinctUntilChanged());
    }
  }

  commit(): void {
    if (this.dynForm && this.dynForm.nForm) {
      this.dynForm.nForm.commitToModel();
      this.querySubmit.next();
      if (!this.tracker || !this.tracker.busy$) {
        this.forceBusySubject.next(true);
        setTimeout(() => this.forceBusySubject.next(false), 100);
      }
      this.cdr.markForCheck();
    }
  }
}
